import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_2 = { class: "font-size-16-600 mt-4" }
const _hoisted_3 = { class: "font-size-12-400 mt-1" }
const _hoisted_4 = { class: "d-flex align-center justify-center ga-1 mt-3" }
const _hoisted_5 = {
  key: 0,
  class: "font-size-12-400 mt-4 ma-auto description-container"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-8"
}

import {computed, ref, onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import {servicesService} from "@/api/services/service";
import {firstLetterUppercase} from "@/components/Helpers/Utils.ts";
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PractitionerBio',
  setup(__props) {

const practitioner = ref(null);
const route = useRoute();
const router = useRouter();

const loadService = async () => {
  const serviceId = route.params.serviceId;
  if (serviceId) {
    await servicesService.getService(serviceId).then(response => {
      practitioner.value = response;
    });
  }
};

onMounted(() => {
  loadService();
});

const getAvatar = computed(() => {
  const creator = practitioner.value?.creator;
  if (creator) {
    const firstName = creator.first_name ?? '';
    const lastName = creator.last_name ?? '';

    return creator.image
        ? {image: creator.image.file?.file_path ?? '', initials: null, name: `${firstName} ${lastName}`}
        : {image: null, initials: (firstName[0] + (lastName[0] || '')).toUpperCase(), name: `${firstName} ${lastName}`};
  }
  return null;
});

const selectPractitioner = () => {
  let practitionerId = practitioner.value?.creator?.id;

  if (practitionerId && route.params.practitionerId) {
    practitionerId = null;
  }

  router.push({
    name: 'book-service',
    params: {id: route.params.serviceId, practitionerId}
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (practitioner.value)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "px-0 pb-5 text-center",
        style: {"background-color":"white","min-height":"500px","padding-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, { class: "avatar-container" }, {
            default: _withCtx(() => [
              (getAvatar.value?.image)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({ backgroundImage: `url(${getAvatar.value.image})` }),
                    class: "avatar-container__image"
                  }, null, 4))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(getAvatar.value?.initials), 1)),
              _createVNode(_component_v_overlay, {
                activator: "parent",
                "location-strategy": "connected",
                "scroll-strategy": "close"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "pa-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getAvatar.value.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_2, _toDisplayString(practitioner.value?.creator.first_name) + " " + _toDisplayString(practitioner.value?.creator.last_name), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(firstLetterUppercase)(practitioner.value?.creator?.role)), 1),
          _createElementVNode("div", _hoisted_4, [
            (practitioner.value?.booking_options?.allow_standard)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  color: "#1EBCD5",
                  icon: "location-icon"
                }))
              : _createCommentVNode("", true),
            (practitioner.value?.booking_options?.allow_phone)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 1,
                  color: "#1EBCD5",
                  icon: "phone-icon"
                }))
              : _createCommentVNode("", true),
            (practitioner.value?.booking_options?.allow_video)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 2,
                  color: "#1EBCD5",
                  icon: "video-icon"
                }))
              : _createCommentVNode("", true)
          ]),
          (practitioner.value?.creator?.bio)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(practitioner.value?.creator?.bio), 1))
            : _createCommentVNode("", true),
          (!_unref(route).params.view)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  class: _normalizeClass([_unref(route).params.practitionerId ? 'secondary-button' : 'transparent secondary-button-color', "b-round-20 outline-btn"]),
                  elevation: "0",
                  height: "32px",
                  width: "234.14px",
                  "x-small": "",
                  onClick: selectPractitioner
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(route).params.practitionerId ? 'Unselect' : 'Select'), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})